
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wines",
      function () {
        return require("private-next-pages/wines/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wines"])
      });
    }
  